import { createSlice } from '@reduxjs/toolkit';

const adLoginSlice = createSlice({
  name: "adLogin",
  initialState: {
    isLoggedIn: false,

  },
  reducers: {
    loginSuccess(state) {
      state.isLoggedIn = true;
   
    },
    logout(state) {
      state.isLoggedIn = false;

    }
  }
});

export const { loginSuccess, logout } = adLoginSlice.actions;
export default adLoginSlice.reducer;
